import PageBanner from "../components/ui/PageBanner";
import achieveImg from "../assets/about-achieve.jpeg";
import "./About.css";

const VALUES = ["Integrity", "Safety", "Equity", "Compassion", "Excellence", "Commitment"];

export default function VisionMission({ setPage }) {
  return (
    <div className="about-page">
      <PageBanner title="Vision & Mission" crumbs={["Home", "About", "Vision & Mission"]} />

      <section className="section section--gray">
        <div className="section-inner">
          <div className="about__layout">
            <div className="about__mission-img">
              <img className="about__img" src={achieveImg} alt="Hospital facilities" loading="lazy" />
            </div>
            <div>
              <p className="section-label">Our Foundation</p>
              <h3 className="section-title">Guided by our mission, vision, and core values</h3>

              <h3 className="about__sub-heading">Our Mission</h3>
              <p className="section-text">
                Affordable &amp; Ethical Healthcare services of International Standards, with Excellence in Technology,
                Process &amp; Capital.
              </p>

              <h3 className="about__sub-heading">Our Vision</h3>
              <p className="section-text">
                To Emerge As A Trusted Healthcare &amp; Educational Brand, That Care &amp; Cure Communities.
              </p>

              <h3 className="about__sub-heading">Our Values</h3>
              <div className="about__values-grid">
                {VALUES.map((v) => (
                  <div key={v} className="about__value-item">
                    <span className="about__value-arrow">&gt;</span> {v}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-inner">
          <div className="about__section-head">
            <p className="section-label">What It Means</p>
            <h3 className="section-title">A commitment you can feel at every step</h3>
            <p className="section-text">
              Our mission and values guide how we treat patients, support families, and deliver reliable outcomes every
              day.
            </p>
          </div>

          <div className="about__cards-grid">
            {[
              {
                title: "Patient-Centered Care",
                desc: "Clear communication, respect, and compassionate support from consultation to recovery.",
              },
              {
                title: "Quality & Safety",
                desc: "Strong clinical standards, safe processes, and continuous improvement across services.",
              },
              {
                title: "Modern Care Delivery",
                desc: "Technology-enabled diagnostics, coordinated teams, and efficient patient flow for timely care.",
              },
            ].map((c) => (
              <div key={c.title} className="card" style={{ padding: 18 }}>
                <h3 className="section-title" style={{ marginBottom: 8 }}>
                  {c.title}
                </h3>
                <p className="section-text" style={{ marginBottom: 0 }}>
                  {c.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="about__actions">
            <button type="button" className="btn-primary" onClick={() => setPage?.("contact")}>
              Book an Appointment
            </button>
            <button type="button" className="btn-outline" onClick={() => setPage?.("services")}>
              Explore Services
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
